export const Currency = {
  USD: 'USD',
  EUR: 'EUR',
}
export type CurrencyType = typeof Currency[keyof typeof Currency];

export const ChipVariation = {
  Skill: 'skill',
  Remote: 'remote',
  Seniority: 'seniority',
  Salary: 'salary',
} as const;
export type ChipVariationType = typeof ChipVariation[keyof typeof ChipVariation];

export const JobSeniority = {
  Junior: 'junior',
  Intermediate: 'intermediate',
  Senior: 'senior',
}
export type JobSeniorityType = typeof JobSeniority[keyof typeof JobSeniority];

export const JobType = {
  Job: 'job',
  JobListing: 'job-listing',
}
export type JobTypeType = typeof JobType[keyof typeof JobType];
